import React, { useEffect, useRef } from 'react'  // useRef は prevLocationRef で使用
import PropTypes from 'prop-types'
import { useParams, useLocation } from 'react-router-dom'
import LineSelector from '../LineSelector'
import TrainPositionList from './TrainPositionList'
import Footer from './TrainPositionsFooter'
import ScrollToTop from '../shared/ScrollToTop'
import LineSwipable from '../LineSwipable'
import TrainPositionToolbar from './TrainPositionToolbar'
import MasterData from '../../data/MasterData'

import { scroller } from 'react-scroll'

const TrainPositionsApp = (props) => {
  const {
    trains,
    updatedAt,
    themeName,
    trainPositionAutoRefresh,
    fetchTrains,
    fetchJrTrains,
    fetchTokyuTrains,
    changeTrainPositionAutoRefresh,
    fetchUserSettings,
    popinfoId,
    openTrainSelectModal,
    appVersion,
  } = props

  const { lineName } = useParams()
  const location = useLocation()
  const prevLocationRef = useRef()
  const initializedRef = useRef(false)
  const reloadTrains = async () => {
    await Promise.all([
      fetchTrains(),
      lineName === 'for_jre' ? fetchJrTrains() : Promise.resolve(),
      lineName === 'for_tokyu' ? Promise.all([
        fetchTokyuTrains('toyoko'),
        fetchTokyuTrains('meguro'),
        fetchTokyuTrains('shinyokohama'),
      ]) : Promise.resolve(),
    ])
  }

  // 初回マウント時のみ実行: 設定取得 + 最初のデータロード
  useEffect(() => {
    if (initializedRef.current) return
    initializedRef.current = true

    const initialize = async () => {
      await fetchUserSettings(popinfoId)
      window.reloadTrains = reloadTrains
      await reloadTrains()
      const stationIdMatch = location.hash.match(/#?(\d+)$/)
      if (stationIdMatch) scrollToStation(stationIdMatch[1])
    }

    initialize()

    return () => {
      window.reloadTrains = undefined
    }
  }, [])

  // trainPositionAutoRefresh が変化したときにインターバルを再設定
  useEffect(() => {
    const intervalId = setInterval(() => {
      if (trainPositionAutoRefresh) {
        reloadTrains()
      }
    }, 45000)

    return () => {
      clearInterval(intervalId)
    }
  }, [trainPositionAutoRefresh])

  useEffect(() => {
    const handleLocationChange = async () => {
      // 参照比較だと同一オブジェクトになる場合があるため、pathname+search+hash を文字列で比較する
      const current = `${location.pathname}${location.search}${location.hash}`
      const prev = prevLocationRef.current

      // マウント時（prev === undefined）はinitialize()でロード済みのためスキップ
      if (prev !== undefined && prev !== current) {
        await reloadTrains()
        const stationIdMatch = current.match(/#(\d+)$/)
        if (stationIdMatch) scrollToStation(`${stationIdMatch[1]}`)
      }

      // 現在のURL文字列を保存
      prevLocationRef.current = current
    }

    handleLocationChange()
  }, [location])

  const scrollToStation = (stationId) => {
    scroller.scrollTo(`station${stationId}`)
  }

  const lineInfo = () => {
    const lineId = MasterData.lineIdByLineName(lineName)
    return MasterData.tabLineById(lineId)
  }

  var backgroundDiv = <div></div>
  if (lineInfo().backgroundClass) {
    backgroundDiv = <div className={`${lineInfo().backgroundClass}`}></div>
  }

  return (
    <LineSwipable currentLineName={lineName} target="trains">
      <ScrollToTop>
        <LineSelector lineName={lineName} type="trains" themeName={themeName} />
        <TrainPositionToolbar themeName={themeName} trainPositionAutoRefresh={trainPositionAutoRefresh} popinfoId={popinfoId} changeTrainPositionAutoRefresh={changeTrainPositionAutoRefresh} />
        {backgroundDiv}
        <TrainPositionList {...props} lineName={lineName} trains={trains} themeName={themeName} openTrainSelectModal={openTrainSelectModal} />
        <Footer lineName={lineName} updatedAt={updatedAt} type="trains" themeName={themeName} appVersion={appVersion} />
      </ScrollToTop>
    </LineSwipable>
  )
}

TrainPositionsApp.propTypes = {
  trains: PropTypes.array.isRequired,
  updatedAt: PropTypes.number,
  themeName: PropTypes.string.isRequired,
  appVersion: PropTypes.string,
  trainPositionAutoRefresh: PropTypes.bool.isRequired,
  fetchTrains: PropTypes.func.isRequired,
  fetchJrTrains: PropTypes.func.isRequired,
  fetchTokyuTrains: PropTypes.func.isRequired,
  changeTrainPositionAutoRefresh: PropTypes.func.isRequired,
  fetchUserSettings: PropTypes.func.isRequired,
  popinfoId: PropTypes.string,
  openTrainSelectModal: PropTypes.func.isRequired,
}

export default TrainPositionsApp
